import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DashboardHeaderComponent } from '../structure/header/header';
import { DashboardSidebarComponent } from '../structure/sidebar/sidebar';
import { ServerTimeService } from '../../services/server-time';
import { DASHBOARD_EVENTS, DASHBOARD_STATS, DASHBOARD_SUMMARY, DEFAULT_DASHBOARD_USER, GENERATION_MIX, LOAD_TIMELINE } from './dashboard.data';
import { DashboardUserProfile } from './dashboard.interfaces';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, DashboardSidebarComponent, DashboardHeaderComponent],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss',
})
export class Dashboard {
  protected readonly user: DashboardUserProfile = DEFAULT_DASHBOARD_USER;
  protected readonly stats = DASHBOARD_STATS;
  protected readonly summaryCards = DASHBOARD_SUMMARY;
  protected readonly events = DASHBOARD_EVENTS;
  protected readonly generationMix = GENERATION_MIX;
  protected readonly loadTimeline = LOAD_TIMELINE;
  protected sidebarCollapsed = false;
  protected mobileSidebarOpen = false;

  constructor(private readonly serverTimeSvc: ServerTimeService) {}

  protected get currentTimeLabel(): string {
    return this.serverTimeSvc.getCurrentTimeLabel();
  }

  protected handleMenuToggle(): void {
    if (window.innerWidth >= 1024) {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      return;
    }
    this.mobileSidebarOpen = !this.mobileSidebarOpen;
  }

  protected getMaxLoad(): number {
    return Math.max(...this.loadTimeline.map((point) => Math.max(point.demand, point.generation)));
  }

  protected chartHeight(value: number): number {
    return Math.max(8, (value / this.getMaxLoad()) * 100);
  }
}
